import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Switch, Route } from 'react-router-dom'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import windowDimensions from 'react-window-dimensions'
import ReactHtmlParser from 'react-html-parser'
import { TransitionGroup } from 'react-transition-group'
import { fetchPageIfNeeded, fetchCustomPostsIfNeeded } from '../actions'
import { DEFAULT_PAGE } from '../reducers/pages'
import { DEFAULT_CUSTOM_POST } from '../reducers/customposts'
import { MainFull } from '../components/Content'
import Thumb from '../components/Thumb'
import { breakpoints } from '../helpers/helpers'
import { SlideUp } from '../components/Transitions'
import Popup from './Popup'

class FeedStylePage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            active: '',
        }
        this.setActivePost = this.setActivePost.bind(this)
    }
    componentWillMount() {
        const { fetchPageIfNeeded, fetchCustomPostsIfNeeded, match } = this.props
    	const pageToFetch = match.path === '/klanten' ? 'klanten' : 'taqtici'
        fetchPageIfNeeded(pageToFetch)
        fetchCustomPostsIfNeeded(pageToFetch)
    }
    setActivePost(postID) {
        this.setState({
            active: postID,
        })
    }
    render() {
        const { posts, windowWidth, location, match } = this.props
        const theCols = windowWidth > breakpoints.xlarge ? 4 : (windowWidth > breakpoints.medium ? 3 : 2)
        const newPosts = posts.reduce((rows, key, index) => (index % theCols === 0 ? rows.push([key]) 
            : rows[rows.length-1].push(key)) && rows, [])
        const postCols = _.zip(...newPosts)

        return (
            <MainFull>
                {postCols.map( (col, i) =>
                    <div className="cell small-6 medium-4 xlarge-3" key={i}>
                        {col.map( (item, j) => item !== undefined && 
                            <Link to={`${match.path}/${item.slug}`} key={j} className="feed-link">
                                <SingleItem title={item.title.rendered} image={item.featured_media} id={item.id}/>
                            </Link>
                        )}
                    </div>
                )}
                <TransitionGroup>
                    <SlideUp key={location.pathname}>
                        <Switch location={location}>
                            <Route path={`${match.path}/:id`} component={Popup}/>
                        </Switch>
                    </SlideUp>
                </TransitionGroup>
            </MainFull>
        )
    }
}

const SingleItem = (props) =>
    <div className="grid-block" onClick={props.onClick}>
        <Thumb thumbid={props.image} size="feed-size" />
        <h5>{ReactHtmlParser(props.title)}</h5>
    </div>

function mapStateToProps(state, ownProps) {
    const pageToFetch = ownProps.match.path === '/klanten' ? 'klanten' : 'taqtici'
    const page = state.pages[pageToFetch] || state.pages[DEFAULT_PAGE]
    const posts = state.customposts[pageToFetch] || state.customposts[DEFAULT_CUSTOM_POST]
    return {
        page: page,
        posts: posts,
    }
}

export default windowDimensions({
    take: () => ({ windowWidth: window.innerWidth }),
    debounce: onResize => _.debounce(onResize, 100),
})(connect(mapStateToProps,{ fetchPageIfNeeded, fetchCustomPostsIfNeeded })(FeedStylePage))


// WEBPACK FOOTER //
// ./src/pages/FeedStylePage.js